import React from 'react';

const EyeBrandingSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='12'
      viewBox='0 0 17 12'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d='M8.75 0.5C3.97727 0.5 1.25 5.75 1.25 5.75C1.25 5.75 3.97727 11 8.75 11C13.5227 11 16.25 5.75 16.25 5.75C16.25 5.75 13.5227 0.5 8.75 0.5Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.75 8C9.99268 8 11 6.99268 11 5.75C11 4.50733 9.99268 3.5 8.75 3.5C7.50732 3.5 6.5 4.50733 6.5 5.75C6.5 6.99268 7.50732 8 8.75 8Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default EyeBrandingSVG;
